import { Component, OnInit } from '@angular/core';
import { ContactsService } from '../shared/services/contacts.service';
import {
  getCampaignsSelector,
  getOpenedTagGroupTooltipsSelector,
  getTagsSelector,
  getTempEditedFiltersSelector,
  getTempTagsSelector
} from '../contacts.reducer';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { Campaign, FilterTag, FilterTagGroup } from '../shared/models/Contact';
import {
  CloseTagGroupTooltip,
  OpenTagGroupTooltip,
  SetFilterItemOpened,
  UpdateEditedFilterList
} from '../contacts.actions';
@Component({
  selector: 'cc-filters-tag',
  templateUrl: './filters-tag.component.html',
  styleUrls: ['./filters-tag.component.scss']
})
export class FiltersTagComponent implements OnInit {
  public tagGroupsList: FilterTagGroup;
  private campaigns: Campaign[];
  public openedTagGroupTooltips: string[];
  public editedFiltersList: string[];

  constructor(public contactsService: ContactsService, private store: Store<IState>) {
    this.store.select(getTagsSelector).subscribe((tagList: FilterTagGroup) => {
      this.tagGroupsList = tagList;
    });

    this.store.select(getTempTagsSelector).subscribe((tempTagList: FilterTagGroup) => {
      const tags = !!tempTagList
        ? Object.entries(tempTagList).map(([key, value]) => {
            if (value !== null) {
              return value;
            }
          })
        : [];
    });

    this.store.select(getCampaignsSelector).subscribe((projects: Campaign[]) => {
      this.campaigns = projects;
    });

    this.store.select(getOpenedTagGroupTooltipsSelector).subscribe((openedTooltips: string[]) => {
      this.openedTagGroupTooltips = openedTooltips;
    });

    this.store.select(getTempEditedFiltersSelector).subscribe((editedFiltersList: string[]) => {
      this.editedFiltersList = editedFiltersList;
    });
  }

  ngOnInit() {}

  // addTag() {
  //   this.contactsService.showFilters();
  //   this.contactsService.showSearchFilters();
  //   this.contactsService.snapshotCallFinishType();
  // }

  removeFilterTag(tag: FilterTag) {
    this.store.dispatch(new SetFilterItemOpened(tag.source));

    if (tag.source === 'clientPhoneNumbers') {
      this.contactsService.switchOffClientsPhoneNumberFilter(tag);
    } else if (tag.callLengthsRange) {
      this.contactsService.switchOffCallLengthFilter(tag);
    } else {
      this.contactsService.switchOffOtherFilter(tag);
    }
    this.store.dispatch(new UpdateEditedFilterList());
    this.contactsService.useNewFilters();
  }

  getKeys(obj) {
    return Object.keys(obj);
  }

  openTagGroupTooltip(groupKey: string) {
    if (this.openedTagGroupTooltips && this.openedTagGroupTooltips.includes(groupKey)) {
      this.store.dispatch(new CloseTagGroupTooltip(groupKey));
    } else {
      this.store.dispatch(new OpenTagGroupTooltip(groupKey));
    }
  }

  isTooltipOpened(groupKey: string) {
    return this.openedTagGroupTooltips ? this.openedTagGroupTooltips.includes(groupKey) : false;
  }

  editFilterGroup(groupKey: string) {
    this.contactsService.openFilterToEdit(groupKey);
  }

  translateKeyName(filterName: string) {
    return this.contactsService.getFilterTitle(filterName);
  }

  removeCollection(groupKey) {
    if (groupKey === 'callLengths') {
      this.contactsService.removeCallLengthCollection();
      this.store.dispatch(new UpdateEditedFilterList());
    } else {
      this.tagGroupsList[groupKey].forEach(tag => {
        this.removeFilterTag(tag);
      });
    }
  }

  tooltipExit($event) {
    if (
      $event.target.className !== 'group-length-label' &&
      $event.target.className !== 'filter-tag-group-wrapper ng-star-inserted' &&
      $event.target.className !== 'filter-tag-group-title' &&
      $event.target.className !== 'material-icons filter-tag-group-edit' &&
      this.openedTagGroupTooltips.length
    ) {
      Object.keys(this.tagGroupsList).forEach(key => {
        this.store.dispatch(new CloseTagGroupTooltip(key));
      });
    }
  }
}
